import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import api from "../../app/api";
import SubmitButton from "../../components/SubmitButton";
import TaskAnswer from "../../components/taskAnswer";
import useAlert from "../../hooks/useAlert";
import Loader from "../../components/Loader";
import BreadCrumb from "../../components/BreadCrumb";
import Model from "../../components/model";
import { FormField } from "../../features/invoices/addInvoice";

const Task = () => {
    const location = useLocation();
    const { showAlert } = useAlert();
    const [isSubmitted, setisSubmitted] = useState(false)
    const [loading, setLoading] = useState(null);
    const [questions, setQuestions] = useState([])
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const isUser = queryParams.get("isUser");
    const encodedEmail = queryParams.get("email");
    const userID = queryParams.get("userID");
    const allowed = queryParams.get("allowed");
    const email = customDecode(encodedEmail);
    const [data, setData] = useState({
        submittedEmail: '',
        submittedName: '',
    })
    let fields = [
        {
            value: data?.submittedEmail,
            setValue: (value) => setData({ ...data, submittedEmail: value }),
            label: "Enter Email",
            placeholder: "Enter Email",
            type: "email",
            id: "submittedEmail",
            required: true,
        },
        {
            value: data?.submittedName,
            setValue: (value) => setData({ ...data, submittedName: value }),
            label: "Enter Name",
            placeholder: "Enter Name",
            type: "text",
            id: "submittedName",
            required: true,
        },
    ]
    const [shareable, setShareable] = useState({});
    const [show, setShow] = useState(false)
    function customDecode(encodedEmail) {
        if (!isUser) {
            return encodedEmail
                ?.split("-")
                ?.map((code) => String.fromCharCode(code - 5))
                .join("");
        }
    }
    const getData = async () => {
        try {
            const response = await api.get(`/share/get?id=${id}&isUser=${isUser}`);
            if (response.data?.status) {
                setShareable(response.data.result);

                if (response.data?.result?.allowedEmails?.filter(item => item.email == email).length < 1 && !isUser && allowed != 'all') {
                    showAlert("Restricted page!", "danger");
                } else {
                    if (
                        (userID === localStorage.getItem("_id") ||
                            response.data?.result?.allowedEmails?.filter(item => item.email == email).length > 0) || allowed == 'all'
                    ) {
                        const formQuestions = response.data?.result?.data?.[0]?.questions;
                        if (!formQuestions?.length) {
                            showAlert("This form is no longer available or has been removed.", "danger");
                        } else {
                            setQuestions(formQuestions);
                        }
                    } else showAlert("Restricted page!", "danger");
                }
            } else {
                showAlert(response.data?.message, "danger");
            }
        } catch (error) {
        } finally {
            setLoading(false)
        }
    };
    const performTask = async () => {
        const error = questions
            ?.filter(
                (item) =>
                    (item.required && item.answer == undefined) || item.answer == "" || item.answer == '--Select an option--'
            )
            .map((item) => `${item.question} is required`);
        if (error?.length != 0) {
            return showAlert(error.join("\n"), "danger");
        }
        setLoading(true);
        try {
            // var formData = new FormData();
            var formData = new FormData();
            questions.forEach((item, index) => {
                const fieldname = `questions[${index}]`;
                formData.append(fieldname + "[_id]", item._id);
                formData.append(
                    fieldname + "[question]",
                    item.question ? item.question : "Not Answered"
                );
                formData.append(
                    fieldname + "[answer]",
                    item.answer ? (Array.isArray(item.answer) ? item?.answer?.join("\\") : item.answer) : "Not Answered"
                );
                formData.append(
                    fieldname + "[answerAttachments]",
                    item.answerAttachments ? item.answerAttachments : []
                );
                formData.append(
                    fieldname + "[comment]",
                    item.comment ? item.comment : ''
                );
                formData.append(
                    fieldname + "[type]",
                    item.type ? item.type : ''
                );
                formData.append(
                    fieldname + "createdAt",
                    item.createdAt ? item.createdAt : ''
                );
                formData.append(
                    fieldname + "description",
                    item.description ? item.description : ''
                );

                item.options?.forEach((option, optionIndex) => {
                    formData.append(`questions[${index}][options][${optionIndex}]`, option);
                })
                formData.append(
                    fieldname + "[description]",
                    item.description ? item.description : ''
                );
                item.emails?.forEach((email, emailIndex) => {
                    formData.append(`questions[${index}][emails][${emailIndex}]`, email._id);
                })
            });

            // questions.forEach((item, index) => {
            //     const fieldname = `questions[${index}]`;
            //     formData.append(fieldname + "[_id]", item._id);
            //     formData.append(
            //         fieldname + "[answer]",
            //         item.answer ? item.answer : "Not Answered"
            //     );
            //     formData.append(
            //         fieldname + "[question]",
            //         item.answer ? item.question : "Not Answered"
            //     );
            //     formData.append(
            //         fieldname + "[type]",
            //         item.answer ? item.type : "Not Answered"
            //     );
            //     formData.append(
            //         fieldname + "[required]",
            //         item.answer ? item.required : "Not Answered"
            //     );
            //     formData.append(
            //         fieldname + "[answerAttachments]",
            //         item.answerAttachments ? item.answerAttachments : []
            //     );
            //     formData.append(
            //         fieldname + "[comment]",
            //         item.comment ? item.comment : ''
            //     );
            // });
            const response = await api.put(`/shareSubmissions/updateForm`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                params: {
                    submittedEmail: allowed == 'all' ? data.submittedEmail : email,
                    submittedName: data.submittedName,
                    shareableID: shareable._id,
                    allowed
                },
            });
            if (response.data?.status) {
                showAlert("Confirmation Submitted!", "success");
                setisSubmitted(true);
                email = "";
            } else {
                showAlert(response.data?.message, "danger");
            }
        } catch (error) {
        } finally {
            setLoading();
        }
    };
    const getAnswer = (id) => {
        const question = questions?.find((item) => item._id == id);
        return question.answer;
    };
    const getComment = (id) => {
        const question = questions?.find((item) => item._id == id);
        return question.comment;
    };
    const setAnswer = (id, answer, checkbox) => {
        if (!checkbox) {
            const updated = questions?.map((item) =>
                item._id == id ? { ...item, answer } : item
            );
            setQuestions(updated);
        } else {
            const question = questions.filter((item) => id == item._id);
            if (question[0].answer?.includes(answer)) {
                const updatedAnswer = question[0].answer?.filter(
                    (item) => item != answer
                );
                const updated = questions?.map((item) =>
                    item._id == id ? { ...item, answer: updatedAnswer } : item
                );
                setQuestions(updated);
            } else {
                const updated = questions?.map((item) =>
                    item._id == id
                        ? {
                            ...item,
                            answer: item.answer ? [...item.answer, answer] : [answer],
                        }
                        : item
                );
                setQuestions(updated);
            }
        }
    };
    const setAttachment = (id, answerAttachments) => {
        const updated = questions?.map((item) =>
            item._id == id ? { ...item, answerAttachments } : item
        );
        setQuestions(updated);
    };
    const removeAtachment = async (id, attachment) => {
        let findQuestion = questions.filter(item => item._id == id)
        let findAttachments = findQuestion[0].answerAttachments
        let updatedAttachments = findAttachments.filter(item => item != attachment)
        findQuestion[0].answerAttachments = updatedAttachments
        await api.delete(`/file/delete?url=${attachment}`);
        const updated = questions?.map((item) =>
            item._id == id ? findQuestion[0] : item
        );
        setQuestions(updated);
    };
    const setComment = (id, comment) => {
        const updated = questions?.map((item) =>
            item._id == id ? { ...item, comment } : item
        );
        setQuestions(updated);
    };
    const setDescription = (id, description, checkbox) => {
        const updated = questions?.map((item) =>
            item._id == id ? { ...item, description } : item
        );
        setQuestions(updated);
    };
    const setEmails = (id, answer) => {
        const updated = questions?.map((item) =>
            item._id == id ? { ...item, emails: answer } : item
        );
        setQuestions(updated)

    };
    const getEmails = (id) => {
        const question = questions?.find((item) => item._id == id);
        return question.emails || [];
    };
    const disabled = false;
    const fresh = location.state?.fresh;
    const isRiskAssesment = location.state?.isRiskAssesment;
    const isAudit = location.state?.isAudit;
    useEffect(() => {
        getData(location.state?._id, { fresh, isRiskAssesment, isAudit });
    }, []);
    useEffect(() => {
        if (allowed == 'all') setShow(true)
    }, [allowed])

    return (
        <div
            style={{
                border: "15px solid #0d6efd50",
                padding: "40px",
                minHeight: "100vh",
            }}
        >
            <BreadCrumb
                flow={[
                    { label: `${shareable && shareable.data ? shareable?.data[0]?.title : ''}` },
                    { label: "Form" },
                ]}
            />
            {allowed == 'all' && <Model title="Form Information" show={show} handleClose={() => { }}>
                {fields.map((item) => (
                    <div className="col-12">
                        <FormField field={item} />
                    </div>
                ))}
                <div className="d-flex justify-content-center mt-4 gap-2">

                    <SubmitButton
                        title={"Continue"}
                        loading={false}
                        onClick={() => {
                            setShow(false);
                        }}
                        color={"success"}
                        loaderColor={"white"}
                        disabled={
                            data.submittedEmail == "" ||
                            data.submittedName == "" ||
                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.submittedEmail)
                        }
                    />
                </div>
            </Model>}
            {questions?.length > 0 ? <div className="d-flex flex-column align-items-end" id="parentTask">
                <div className="row d-flex justify-content-evenly w-100" id="capture">
                    {questions?.map((item, index) => {
                        const isBoolean = item.type == "boolean";
                        return (
                            <TaskAnswer
                                key={index}
                                item={item}
                                isBoolean={isBoolean}
                                getAnswer={getAnswer}
                                setAnswer={setAnswer}
                                disabled={disabled}
                                getEmails={getEmails}
                                setEmails={setEmails}
                                setComment={setComment}
                                setAttachment={setAttachment}
                                getComment={getComment}
                                removeAtachment={removeAtachment}
                                data={{}}
                                user={shareable?.createdBy}
                                setDescription={setDescription}
                            />
                        );
                    })}
                </div>
                <SubmitButton
                    title={
                        "Submit Answers"
                    }
                    color={"primary"}
                    loading={loading}
                    onClick={() => performTask(fresh, isRiskAssesment, isAudit)}
                    loaderColor={"white"}
                    disabled={isSubmitted}
                />
            </div> : (loading === false ? null : <Loader loading={true} center />)}
        </div>
    );
};

export default Task;
